import { render, staticRenderFns } from "./CTabs.vue?vue&type=template&id=31d43e30"
import script from "./CTabs.vue?vue&type=script&lang=js"
export * from "./CTabs.vue?vue&type=script&lang=js"
import style0 from "./CTabs.vue?vue&type=style&index=0&id=31d43e30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports